import { Sha256 } from '@aws-crypto/sha256-js'
import { Buffer } from 'buffer'

export const generateDigest = async () => {
  const roundedTime = getRoundedTime()
  const sha256 = new Sha256()
  sha256.update(`_${roundedTime}`)
  const digest = await sha256.digest()
  return Buffer.from(digest).toString('hex')
}

const getRoundedTime = () => {
  const now = new Date()
  const minutes = Math.floor(now.getMinutes() / 5) * 5
  now.setMinutes(minutes)
  now.setSeconds(0)
  now.setMilliseconds(0)
  const isoTime = now.toISOString().slice(0, 16)
  return isoTime
}

